import { useState, useEffect } from "react";
import { FileDrop } from "react-file-drop";
import { useRouter } from "next/router";
import Image from "next/image";
import getCommonLocales from "../../locales/locales_common";
import { useStore } from "../../stores/use_global_state";
import { addToLocalStorage } from "../../utils/nonAuthLocalStorage";

export function DropZoneBig({ pageType = "", style, uploadFile, errorStatus, showModalCallback }) {
	const { state } = useStore();
	const router = useRouter();

	const { locale } = router;

	const dictionary = getCommonLocales(locale);

	const [isDraggingOver, setIsDraggingOver] = useState(false);

	useEffect(() => {
		if (errorStatus) {
			setIsDraggingOver(false);
		}
	}, [errorStatus]);

	const handleDragEnter = () => setIsDraggingOver(true);

	const handleDragLeave = () => setIsDraggingOver(false);

	const handleFileDrop = (files, event) => {
		event.preventDefault();
		if (state.isAuth) {
			uploadFile(files);
			return;
		}
		nonAuthHandler();
	};

	const nonAuthHandler = () => {
		if (state.isAuth) return;
		addToLocalStorage("turnIntoVideo");
		showModalCallback();
	};

	return (
		<div className={`${style.left} ${style.drop_wrapper}`}>
			<FileDrop className={`${style.drop_area} ${isDraggingOver ? style.drag_enter : undefined}`} onDragOver={handleDragEnter} onDragLeave={handleDragLeave} onDrop={handleFileDrop}>
				<Image width="80" height="60" src="/ico/video.png" alt="video" />
				<input
					onChange={(event) => uploadFile(event.target.files)}
					disabled={!state.isAuth}
					type="file"
					name=""
					id="video_file"
					accept={`${pageType === "" ? ".mp4,.mov, .mkv, video/mp4, .webm," : ""} .jpg, .jpeg, .png, image/png, image/jpeg`}
				/>

				<label htmlFor="video_file" onClick={nonAuthHandler} id="upload-file">
					<div className={style.upload_video_img}>
						<Image src="/ico/upload_icon.svg" alt="Upload video" width="28" height="28" style={{ objectFit: "contain", maxWidth: "100%" }} />
					</div>
					<span className={style.adaptive_off}>{dictionary["Upload file"]}</span>
				</label>
				<p className={`${style.desc} ${style.adaptive_off}`}>{dictionary["or Drag and drop file here"] || "or Drag and drop file here"}</p>
				<p
					className={`${style.info} ${style.adaptive_off}`}
					dangerouslySetInnerHTML={{ __html: `${pageType === "" ? dictionary["Service accepts .mp4, .mov, .ts, .avi, .mkv, .webm, .mpg, .jpg, .png files"] : ".jpg, .jpeg, .png"}` }}
				/>
				{pageType === "" && <p className={`${style.info} ${style.adaptive_off}`} dangerouslySetInnerHTML={{ __html: `${dictionary["Best solution for portrait video/photo"]}` }} />}
			</FileDrop>
		</div>
	);
}
